import React from 'react'
import {COLOR_LIST} from "../common/constants/color.constant";
import _ from "lodash";

const colorList = _.orderBy(COLOR_LIST, 'colorKey');

// @ts-ignore
const EditShadowDetails = ({parentForm, handleShadowDetailsChanges}) => {
    const colorMap = _.keyBy(COLOR_LIST, 'colorKey');

    return (
        <>
            <div className="ml-2 field-label">
                Shadow
            </div>

            <div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">

                    <div className="field-container">
                        <select
                            className="input-field"
                            id="shadowColorKey"
                            name="shadowColorKey"
                            value={parentForm?.shadowColorKey}
                            onChange={handleShadowDetailsChanges}>
                            <option value="">Choose Shadow Color</option>
                            {colorList?.map((colorDetail, index) => (
                                <option key={index}
                                        value={colorDetail.colorKey}>{colorDetail.colorName}</option>
                            ))}
                        </select>
                    </div>

                    <div className="field-container">
                        <select
                            className="input-field"
                            id="shadowColorCodeKey"
                            name="shadowColorCodeKey"
                            value={parentForm?.shadowColorCodeKey}
                            onChange={handleShadowDetailsChanges}>
                            <option value="">Choose Shadow Color Shade</option>
                            {colorMap[parentForm?.shadowColorKey]?.colorCodes.map((colorCodeDetail, index) => (
                                <option key={index}
                                        value={colorCodeDetail.colorCodeKey}>{colorCodeDetail.colorCodeName}</option>
                            ))}
                        </select>
                    </div>

                </div>
            </div>

            <div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">

                    <div className="field-container">
                        <input
                            type="number"
                            className="input-field"
                            id="shadowOffsetX"
                            name="shadowOffsetX"
                            value={parentForm?.shadowOffsetX}
                            onChange={handleShadowDetailsChanges}>
                        </input>
                    </div>

                    <div className="field-container">
                        <input
                            type="number"
                            className="input-field"
                            id="shadowOffsetY"
                            name="shadowOffsetY"
                            value={parentForm?.shadowOffsetY}
                            onChange={handleShadowDetailsChanges}>
                        </input>
                    </div>

                </div>
            </div>

            <div className="flex flex-wrap justify-start move-up-10">
                <div className="field-group-container">

                    <div className="field-container">
                        <input
                            type="number"
                            className="input-field"
                            id="shadowBlur"
                            name="shadowBlur"
                            value={parentForm?.shadowBlur}
                            onChange={handleShadowDetailsChanges}>
                        </input>
                    </div>

                </div>
            </div>

        </>
    )
}

export default EditShadowDetails
